import { Path } from "~/v2/path";
import type {
  AccountStatusMapFunction,
  AccountStatusProps,
} from "./AccountStatusMap";

export const ActionRequired = ({
  details,
  accountDocumentRequests,
}: AccountStatusProps): ReturnType<AccountStatusMapFunction> => {
  const isReviewStatusNull = details?.review_status === null;
  const isDocumentRequested = (details?.review_status ?? "") === "PENDING_USER";

  // Action is not required from user
  if (!isDocumentRequested && isReviewStatusNull) {
    return {
      message: "Application submitted: In review",
    };
  }

  if (!isDocumentRequested) {
    return {
      title: "Documents submitted: In review",
      message: "Please give us up to 24-72 hours to review",
    };
  }

  // Edge case catch - user action is required but no document requests to action on...
  const hasDocumentRequests = (accountDocumentRequests?.length ?? 0) > 0;
  if (!hasDocumentRequests) {
    return null;
  }

  return {
    variant: "warning",
    message: "Documents Requested",
    button: {
      text: "Submit Documents →",
      to: Path.ROUTE_PROFILE_DOCUMENT_REQUESTS,
    },
  };
};
